import React from "react";
import "./Timeline.css";

const Timeline = ({ events, onProjectClick }) => {
  return (
    <div className="timeline">
      {events.map((event, index) => (
        <div key={index} className="timeline-item">
          <div className="timeline-marker"></div>
          <div className="timeline-content">
            <div className="timeline-date">{event.date}</div>
            <h3 className="timeline-title">{event.title}</h3>
            <p className="timeline-description">{event.description}</p>
            {event.projects && event.projects.length > 0 && (
              <div className="timeline-projects">
                <h4>Related Projects:</h4>
                <div className="project-tags">
                  {event.projects.map((project, pIndex) => (
                    <span
                      key={pIndex}
                      className="project-tag"
                      onClick={() => onProjectClick(project)}
                    >
                      {project.name}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;